import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle-check-green",
  "use": "circle-check-green-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol viewBox=\"0 0 19 19\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"circle-check-green\">\n<circle cx=\"9.5\" cy=\"9.5\" r=\"9.5\" fill=\"#00CC3F\" fill-opacity=\"0.2\" />\n<path d=\"M6 9.41808L8.74326 12L13 7\" stroke=\"#00CC3F\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol